module.exports = __webpack_public_path__ + "static/media/1000937.cb8c81e0.png";